<template>
  <div class="posts">
    <div v-if="this.id === 'uthum_mohotha'"><UthumMohotha /></div>
    <div v-else-if="this.id === 'apannaka_prathipadawa'">
      <ApannakaPrathipadawa />
    </div>
    <div v-else-if="this.id === 'lowthuru_suwade'"><LowthuruSuwade /></div>
    <div v-else-if="this.id === 'vijam_bana'"><VijamBana /></div>
    <div v-else-if="this.id === 'amadoraviwaraviya'"><Amadoraviwaraviya /></div>
    <div v-else><Amadoraviwaraviya /></div>
  </div>
</template>

<script>
import UthumMohotha from "@/articles/UthumMohotha.vue";
import ApannakaPrathipadawa from "@/articles/ApannakaPrathipadawa.vue";
import LowthuruSuwade from "@/articles/LowthuruSuwade.vue";
import VijamBana from "@/articles/VijamBana.vue";
import Amadoraviwaraviya from "@/articles/AmadoraViwaraviya.vue";

export default {
  name: "Article",
  props: ["id"],
  components: {
    UthumMohotha,
    ApannakaPrathipadawa,
    LowthuruSuwade,
    VijamBana,
    Amadoraviwaraviya
  }
};
</script>

<style>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  margin: 30px auto;
}

.posts {
  font-size: 18px;
}
</style>
